"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMap;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * MIT license
 */

/**
 * https://github.com/facebook/immutable-js/blob/master/src/Map.js
 * This is to avoid importing the full `immutable` module for type check
 * @returns `true` if object is an immutable.js Map instance
 */
var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

function isMap(maybeMap) {
  return Boolean(maybeMap && maybeMap[IS_MAP_SENTINEL]);
}
//# sourceMappingURL=is-immutable-map.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/es5/utils/is-immutable-map.js
// module id = 258
// module chunks = 35783957827783